import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, closest, findIn, findAllIn, find} from "@elements/dom-utils";
import asyncAppend from "@elements/async-append";
import axios from "axios";

export function init() {
    onFind('.js-project-teaser__more', function (toggle) {
        let container = closest('.js-project-teaser', toggle),
            isLoaded = false;

        on('click', () => {
            if (hasClass('is-open', container)) {
                removeClass('is-open', container);
            } else {
                console.log(container, isLoaded)
                let pendingRequest = axios({method: 'GET', url: container.getAttribute('data-content-url') });

                asyncAppend({
                    target: findAllIn('.js-project-teaser__content', container),
                    loading: findAllIn('.js-project-teaser__loading', container)
                }, pendingRequest.then((x) => x.data));

                isLoaded = true;
                addClass('is-open', container);
            }
        }, toggle);
    });
}